import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { CompanyCesionarioDTO } from '../../interfaces/company-cesionario.interface';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatSort, Sort } from '@angular/material/sort';

@Component({
  selector: 'app-formula-cesionario-table',
  templateUrl: './formula-cesionario-table.component.html',
  styleUrls: ['./formula-cesionario-table.component.scss']
})
export class FormulaCesionarioTableComponent implements OnInit, AfterViewInit{
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;
  @ViewChild(MatSort, {static: true}) sort: MatSort;
  public dataSource: MatTableDataSource<CompanyCesionarioDTO>;
  public columns = [
    'CesionarioName',
    'ReceivedInvoices',
    'TotalAmountReceivedInvoices',
    'TransferedInvoices',
    'TotalAmountTransferedInvoices'
  ];

  @Input() cesionarios: Array<CompanyCesionarioDTO> = [];
  @Input() page: number;
  @Input() pageSize: number;
  @Input() totalRows: number;
  @Input() sortColumn: string;
  @Input() sortDirection: string;

  @Output() sorting = new EventEmitter<any>;
  @Output() paging = new EventEmitter<any>;

  constructor() {
    this.dataSource = new MatTableDataSource<CompanyCesionarioDTO>([]);
  }

  ngOnInit(): void {
    this.setDataSource();
    this.setSorting();
  }

  ngAfterViewInit(): void {
  }

  private setDataSource() {
    this.dataSource.data = this.cesionarios;
    this.paginator.pageIndex = this.page -1;
    this.paginator.pageSize = this.pageSize;
    this.paginator.length = this.totalRows;
  }

  private setSorting() {
    this.sort.active = this.sortColumn;
    if(this.sortDirection)
      this.sort.direction = this.sortDirection === 'asc' ? 'asc': 'desc';
  }

  changePagination(pageEvent: PageEvent) {
    this.paging.emit({
      page: pageEvent.pageIndex + 1,
      pageSize: pageEvent.pageSize
    });
  }

  changeSorting(sort: Sort) {
    this.sorting.emit({
      sortColumn: sort.active,
      sortOrder: sort.direction.toLowerCase()
    });
  }

}
